module.exports = {
  integrationError: -2,
  pending: 0,
  scheduled: 50,
  searching: 100,
  dispatched: 200,
  onTheWay: 300,
  arrived: 400,
  clientNoShow: 500,
  clientInTaxi: 600,
  canceling: 900,
  finished: 955,
  canceled: 956,
  modified: 957,
  dispatcherCancelled: 960,
  canceledBySystem: 1000,
};
